import React from 'react'
import { FieldErrors } from 'react-hook-form/dist/types'
import cl from 'classnames'
import isEmpty from 'lodash/isEmpty'

import FormErrorAlert from 'Shared/atoms/FormErrorAlert'
import { getYupFailedValidationFields } from 'Shared/utils/validation'

import styles from './styles.module.scss'

interface Props {
	errors: FieldErrors
	errorPrefix: string
	labels: { [key: string]: string }
	showRequiredFields?: boolean
	className?: string
	isPositionFixed?: boolean
	isPositionSticky?: boolean
	stickyClassName?: string
	additionalFieldErrors?: string[]
	showAdditionalFieldErrors?: boolean
}

const FormYupError: React.FC<Props> = ({
	errorPrefix,
	errors,
	labels,
	className,
	isPositionFixed,
	isPositionSticky,
	stickyClassName,
	additionalFieldErrors,
	showAdditionalFieldErrors
}) => {
	const failedValidationFields = errors ? getYupFailedValidationFields(errors, labels) : []

	const alertComponent = (
		<FormErrorAlert
			errorPrefix={errorPrefix}
			isPositionFixed={isPositionFixed}
			className={className}
			failedValidationFields={failedValidationFields}
			{...(showAdditionalFieldErrors ? { additionalFieldErrors } : {})}
		/>
	)

	return (
		<>
			{isPositionSticky && !isEmpty(errors) ? (
				<div className={cl({ [styles.sticky]: isPositionSticky }, stickyClassName)}>
					{alertComponent}
				</div>
			) : (
				alertComponent
			)}
		</>
	)
}

export default FormYupError
